import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=8fbabbb6&scoped=true&lang=pug&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=8fbabbb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbabbb6",
  null
  
)

export default component.exports